
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black px-8 py-12">
      <div className="max-w-[1600px] mx-auto">
        <div className="bg-charcoal-dark rounded-2xl px-12 lg:px-20 py-16 relative overflow-hidden border border-gray-900">
          {/* Watermark */}
          <div 
            className="absolute bottom-4 left-1/2 -translate-x-1/2 text-[140px] font-semibold select-none pointer-events-none opacity-[0.03]"
            style={{ fontFamily: 'Cinzel, serif', letterSpacing: '0.2em' }}
          >
            MACGOC
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative z-10">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <h3 
                className="text-2xl font-semibold mb-3 tracking-[0.2em]"
                style={{
                  fontFamily: 'Cinzel, serif',
                  background: 'linear-gradient(90deg, #7A6A5A 0%, #A89078 20%, #C4B8A8 40%, #D8CCC0 50%, #C4B8A8 60%, #A89078 80%, #7A6A5A 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                MACGOC
              </h3>
              <p className="text-copper-light text-sm mb-8">Strategic Advisory Platform</p>
              <p className="text-gray-500 text-sm leading-relaxed">
                Enterprise-grade consulting services operating through U.S.-registered entities, delivering strategic advisory across critical business verticals.
              </p>
            </div>

            {/* Services Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Services</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/services/technology" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Technology & Digital
                  </Link>
                </li>
                <li>
                  <Link to="/services/healthcare" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Healthcare Operations
                  </Link>
                </li>
                <li>
                  <Link to="/services/logistics" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Logistics Advisory
                  </Link>
                </li>
                <li>
                  <Link to="/services/fuel-retail" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Fuel Retail Consulting
                  </Link>
                </li>
                <li>
                  <Link to="/services/capital-advisory" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Capital Advisory
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Company</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    About MACGOC
                  </Link>
                </li>
                <li>
                  <Link to="/leadership" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Leadership
                  </Link>
                </li>
                <li>
                  <Link to="/industries" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Industries
                  </Link>
                </li>
                <li>
                  <Link to="/insights" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Insights
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-sm text-gray-500 hover:text-copper-light transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
              <div className="flex items-center gap-4 mt-8">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-linkedin-line text-xl text-gray-600 hover:text-copper-light transition-colors"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-xl text-gray-600 hover:text-copper-light transition-colors"></i>
                </a>
              </div>
            </div>

            {/* Newsletter Column */}
            <div>
              <h4 className="text-base font-semibold text-white mb-4">Stay Informed</h4>
              <p className="text-sm text-gray-500 mb-6">Executive insights delivered monthly</p>
              <form className="relative" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  placeholder="Email address"
                  className="w-full bg-charcoal border border-gray-800 rounded-lg h-12 px-4 pr-14 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-copper/50 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-1 top-1 w-10 h-10 rounded-lg flex items-center justify-center transition-colors"
                  style={{
                    background: 'linear-gradient(135deg, rgba(122, 106, 90, 0.4) 0%, rgba(168, 144, 120, 0.3) 100%)',
                  }}
                >
                  <i className="ri-arrow-right-line text-copper-light text-lg"></i>
                </button>
              </form>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-16 pt-8 border-t border-gray-800 relative z-10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-xs text-gray-600 text-center md:text-left">
                © {currentYear} MACGOC. Operating through U.S.-registered entities.
              </p>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-gray-600 hover:text-copper-light transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
